import React, {useState} from 'react';

import createCtx from 'coreUtils/createCtx';

import {IProductDetailContext} from './IProductDetailContext';

export const [useProductDetailContext, ProductDetailContext] = createCtx<IProductDetailContext>();

export const ProductDetailProvider = ({children}: React.PropsWithChildren) => {
	const [isBreadCrumbsShow, setIsBreadCrumbsShow] = useState<boolean>(false);

	return (
		<ProductDetailContext
			value={{
				isBreadCrumbsShow,
				setIsBreadCrumbsShow,
			}}
		>
			{children}
		</ProductDetailContext>
	);
};
